import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  reduxImage: null,
  reduxNameKr: null,
  count: 0,
};

const reducers = {
  changeMe: (state, action) => {
    state.reduxImage = action.payload.image;
    state.reduxNameKr = action.payload.nameKr;
  },
  addCount: (state) => {
    state.count += 1;
  },

  changeCount: (state, action) => {
    state.count = action.payload;
  },
};

const name = 'artist';
export const artistSlice = createSlice({
  name,
  initialState,
  reducers,
});

export const selectArtistState = (state) => state.artist;
export const artist = artistSlice.name;
export const artistReducer = artistSlice.reducer;
export const artistAction = artistSlice.actions;

export const artistSelector = {
  selectArtistState,
};
